export default "__VITE_ASSET__DFhZ9COc__"